import { InsertDriveFileOutlined } from '@mui/icons-material';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';

import { SearchHitContract } from '../../components/SearchHitContract/SearchHitContract';
import { SearchRefinementListItemCuriosity } from '../../components/SearchRefinementListItemCuriosity/SearchRefinementListItemCuriosity';
import { SearchDateRange } from '../../filters/SearchDateRange/SearchDateRange';
import { SearchRefinementList } from '../../filters/SearchRefinementList/SearchRefinementList';
import { FacetVariant } from '../../types/FacetVariant.ts';
import { SearchConfigItem } from '../../types/SearchConfigItem';
import { SearchFilterAttribute } from '../../types/SearchFilterAttribute';
import { SearchIndex } from '../../types/SearchIndex';
import { SearchIndexConfigFactoryOptions } from '../../types/SearchIndexConfigFactoryOptions';
import { createSearchFilterAttributeItem } from '../../util/createSearchFilterAttributeItem';
import { createSearchSortByItemValue } from '../../util/createSearchSortByItemValue.ts';
import { toNumberRangeRouteValue } from '../../util/mapStateToRoute.ts';

const indexName = SearchIndex.CONTRACT;

export const contractSearchIndexConfig = ({ t }: SearchIndexConfigFactoryOptions): SearchConfigItem => {
  return {
    title: t('indexes.contract.title'),
    description: t('indexes.contract.description'),
    icon: InsertDriveFileOutlined,
    indexName,
    slug: 'ctr',
    hitComponent: SearchHitContract,
    filters: [
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.CREATED_AT,
        facetVariant: FacetVariant.RANGE,
        slug: 'created',
        componentProps: {
          title: t('filter.createdAt.title'),
        },
        component: SearchDateRange,
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.VALID_FROM,
        facetVariant: FacetVariant.RANGE,
        slug: 'valid-from',
        componentProps: {
          title: t('filter.validFrom.title'),
        },
        component: SearchDateRange,
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.VALID_TO,
        facetVariant: FacetVariant.RANGE,
        slug: 'valid-to',
        componentProps: {
          title: t('filter.validTo.title'),
        },
        component: SearchDateRange,
        valueStateToRoute: toNumberRangeRouteValue,
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.SUPPLIER_ID_PARENT,
        facetVariant: FacetVariant.REFINEMENT_LIST,
        slug: 'supplier',
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.supplier.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.SUPPLIER,
          },
        },
      }),
      createSearchFilterAttributeItem({
        attribute: SearchFilterAttribute.COMMODITY_GROUP_ID,
        facetVariant: FacetVariant.REFINEMENT_LIST,
        slug: 'commodity-group',
        component: SearchRefinementList,
        componentProps: {
          title: t('filter.commodityGroup.title'),
          itemComponent: SearchRefinementListItemCuriosity,
          itemComponentProps: {
            ns: CuriosityNamespaceType.COMMODITY_GROUP,
          },
        },
      }),
    ],
    sortByItems: [
      {
        label: t('sortBy.relevance'),
        value: createSearchSortByItemValue(indexName),
        slug: 'relevance',
        isDefault: true,
      },
      {
        label: t('sortBy.createdAtAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT),
        slug: 'created-at:asc',
      },
      {
        label: t('sortBy.createdAtDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.CREATED_AT, true),
        slug: 'created-at:desc',
      },
      {
        label: t('sortBy.priceUnitAsc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_UNIT),
        slug: 'price-unit:asc',
      },
      {
        label: t('sortBy.priceUnitDesc'),
        value: createSearchSortByItemValue(indexName, SearchFilterAttribute.PRICE_UNIT, true),
        slug: 'price-unit:desc',
      },
    ],
  };
};
